import { t } from '@lingui/core/macro';
import { ErrorCode } from '@luminovo/api-contracts';
import { errorCodeTranslations } from '@luminovo/data-stack';
import { CenteredLayout, CircleAlertFilledIcon, NonIdealState, SecondaryButton } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';
import { CircleCheckIcon, RefreshCwIcon, WifiOffIcon } from 'lucide-react';
import type { JSX } from 'react';

import { withLogOut } from './SadBox';

export function NewVersionAvailable(): JSX.Element {
    return (
        <CenteredLayout>
            <NonIdealState
                title={t`New version available`}
                description={t`A new version of Luminovo is available, please reload the page to update.`}
                variant="success"
                icon={<CircleCheckIcon />}
                action={{
                    onClick: () => window.location.reload(),
                    startIcon: <RefreshCwIcon />,
                    children: t`Refresh page`,
                }}
            />
        </CenteredLayout>
    );
}

export function NetworkConnectionProblem(): JSX.Element {
    return (
        <CenteredLayout>
            <NonIdealState
                variant="error"
                icon={<WifiOffIcon />}
                title={t`No internet`}
                description={t`Please check your internet connection and try again.`}
                action={{
                    onClick: () => window.location.reload(),
                    startIcon: <RefreshCwIcon />,
                    children: t`Refresh page`,
                }}
            />
        </CenteredLayout>
    );
}

export function ErrorCodeProblem({ code, onLogOut }: { code: ErrorCode; onLogOut?: () => void }): JSX.Element {
    return (
        <CenteredLayout>
            <NonIdealState
                variant="error"
                icon={<CircleAlertFilledIcon />}
                title={t`There was a problem`}
                description={transEnum(code, errorCodeTranslations)}
                action={withLogOut(
                    <SecondaryButton
                        size="small"
                        startIcon={<RefreshCwIcon />}
                        onClick={() => window.location.reload()}
                    >
                        {t`Refresh page`}
                    </SecondaryButton>,
                    onLogOut,
                )}
            />
        </CenteredLayout>
    );
}
